import {
  leftArrow,
  rightArrow,
  customLeftArrow,
  customRightArrow,
} from '../../GroupsList/customArrowStyle';

export const customArrowStyle = (breakpoint) => {
  let styles = {
    leftArrowStyle: leftArrow(breakpoint),
    rightArrowStyle: rightArrow(breakpoint),
    isSmall: true,
  };

  if (breakpoint === 'm' || breakpoint === 'l') {
    styles = {
      ...styles,
      leftArrowStyle: customLeftArrow(breakpoint),
      rightArrowStyle: customRightArrow(breakpoint),
    };
  }

  return styles;
};
